module.exports = __webpack_public_path__ + "img/nabl_gallery14.09bee45a.jpg";